/* snipetell header-controls v2 */
(function () {
  if (window.__snipetellHeaderControls) return;
  window.__snipetellHeaderControls = true;

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }

  ready(function () {
    /* THEME — first visit always light; only stored choice can be dark */
    var root = document.documentElement;
    var themeBtn = document.querySelector("[data-theme-toggle]") || document.getElementById("theme-toggle");
    var THEME_KEY = "snipetell_user_theme";
    function applyTheme(theme, persist) {
      var t = theme === "dark" ? "dark" : "light";
      root.setAttribute("data-theme", t);
      try { root.style.colorScheme = t; } catch (e) {}
      if (persist) {
        try { localStorage.setItem(THEME_KEY, t); } catch (e) {}
      }
      if (themeBtn) {
        themeBtn.setAttribute("aria-pressed", t === "dark" ? "true" : "false");
        themeBtn.setAttribute("aria-label", t === "dark" ? "Switch to light theme" : "Switch to dark theme");
      }
    }
    var saved = null;
    try { saved = localStorage.getItem(THEME_KEY); } catch (e) {}
    /* Never use prefers-color-scheme / browser default */
    applyTheme(saved === "dark" || saved === "light" ? saved : "light", false);
    if (themeBtn) {
      themeBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var cur = (root.getAttribute("data-theme") || "light");
        applyTheme(cur === "dark" ? "light" : "dark", true);
      }, true);
    }

    /* MOBILE NAV */
    var openBtn = document.getElementById("nav-open");
    var closeBtn = document.getElementById("nav-close");
    var nav = document.getElementById("mobile-nav");
    var backdrop = document.getElementById("nav-backdrop");
    function openNav() {
      if (!nav) return;
      nav.hidden = false;
      nav.removeAttribute("hidden");
      if (backdrop) { backdrop.hidden = false; backdrop.removeAttribute("hidden"); }
      document.body.classList.add("nav-open");
      if (openBtn) openBtn.setAttribute("aria-expanded", "true");
    }
    function closeNav() {
      if (!nav) return;
      nav.hidden = true;
      if (backdrop) backdrop.hidden = true;
      document.body.classList.remove("nav-open");
      if (openBtn) openBtn.setAttribute("aria-expanded", "false");
    }
    if (openBtn) openBtn.addEventListener("click", function (e) { e.preventDefault(); openNav(); }, true);
    if (closeBtn) closeBtn.addEventListener("click", function (e) { e.preventDefault(); closeNav(); }, true);
    if (backdrop) backdrop.addEventListener("click", closeNav, true);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeNav(); });

    
    /* CURRENCY / COUNTRY — reliable Shopify localization submit */
    var picker = document.querySelector("[data-loc-picker]");
    if (picker) {
      var toggle = picker.querySelector("[data-loc-toggle]");
      var panel = document.getElementById("LocPanel") || picker.querySelector(".loc-picker__panel");
      var search = picker.querySelector("[data-loc-search]");
      var list = picker.querySelector("[data-loc-list]");
      var locForm = document.getElementById("LocFormFallback") || document.querySelector("form.shopify-localization-form") || document.querySelector('form[action*="localization"]');
      var countryInput = document.getElementById("LocCountryInput") || (locForm && locForm.querySelector('[name="country_code"]')) || picker.querySelector("[data-loc-input]");

      function setOpen(open) {
        if (!panel || !toggle) return;
        if (open) {
          panel.hidden = false;
          panel.removeAttribute("hidden");
          panel.style.display = "";
        } else {
          panel.hidden = true;
          panel.setAttribute("hidden", "");
        }
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        picker.classList.toggle("is-open", !!open);
        if (open && search) try { search.focus(); } catch (e) {}
      }

      if (toggle) {
        toggle.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var isOpen = picker.classList.contains("is-open") || (panel && !panel.hidden);
          setOpen(!isOpen);
        });
      }
      document.addEventListener("click", function (e) {
        if (picker && !picker.contains(e.target)) setOpen(false);
      });

      if (search && list) {
        search.addEventListener("input", function () {
          var q = (search.value || "").toLowerCase().trim();
          list.querySelectorAll("[data-loc-country]").forEach(function (btn) {
            var name = (btn.getAttribute("data-loc-name") || "").toLowerCase();
            var code = (btn.getAttribute("data-loc-country") || "").toLowerCase();
            var cur = (btn.getAttribute("data-loc-currency") || "").toLowerCase();
            var match = !q || name.indexOf(q) >= 0 || code.indexOf(q) >= 0 || cur.indexOf(q) >= 0;
            btn.hidden = !match;
            btn.style.display = match ? "" : "none";
          });
        });
      }

      function submitCountry(code, currency) {
        if (!code) return;
        // Prefer native Shopify localization form
        if (locForm && countryInput) {
          countryInput.value = code;
          // Ensure return_to is current path (Shopify may already include one)
          var existingReturn = locForm.querySelectorAll('[name="return_to"]');
          if (!existingReturn.length) {
            var rt = document.createElement("input");
            rt.type = "hidden";
            rt.name = "return_to";
            rt.value = window.location.pathname + window.location.search;
            locForm.appendChild(rt);
          } else {
            existingReturn.forEach(function (el, i) {
              if (i === 0) el.value = window.location.pathname + window.location.search;
              else el.parentNode.removeChild(el);
            });
          }
          var label = picker.querySelector("[data-loc-label]");
          if (label && currency) label.textContent = currency;
          // requestSubmit fires validation + submit event; fall back to submit()
          try {
            if (typeof locForm.requestSubmit === "function") locForm.requestSubmit();
            else locForm.submit();
          } catch (err) {
            locForm.submit();
          }
          return;
        }
        // Fallback: build a temporary form
        var f = document.createElement("form");
        f.method = "POST";
        f.action = "/localization";
        f.style.display = "none";
        function add(name, value) {
          var i = document.createElement("input");
          i.type = "hidden";
          i.name = name;
          i.value = value;
          f.appendChild(i);
        }
        add("form_type", "localization");
        add("_method", "put");
        add("country_code", code);
        add("return_to", window.location.pathname + window.location.search);
        document.body.appendChild(f);
        f.submit();
      }

      picker.querySelectorAll("[data-loc-country]").forEach(function (btn) {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          var code = btn.getAttribute("data-loc-country");
          var currency = btn.getAttribute("data-loc-currency") || code;
          submitCountry(code, currency);
        });
      });
    }


    /* ACCOUNT DROPDOWNS */
    document.querySelectorAll("details.hdr-drop").forEach(function (d) {
      d.addEventListener("toggle", function () {
        if (d.open) {
          document.querySelectorAll("details.hdr-drop").forEach(function (o) {
            if (o !== d) o.open = false;
          });
        }
      });
    });
  });
})();
